export default __webpack_public_path__ + "static/media/comic17_2.75e03ce4.png";